import {useEffect,} from 'react';

import {useRatePlans} from '../hooks/useRatePlans.ts';
import {RatePlan} from '../types';
import {FieldProps} from 'formik';
import {useAuth} from "../../../hooks/useAuth.ts";
import {FormikGenericCombobox} from "@flexinet/ui-components";
import {TextInputProps} from "@mantine/core";

export const RatePlansAutocomplete = (props: FieldProps & TextInputProps) => {

    const {user} = useAuth()

    if (!user) {
        throw new Error('user is required parameter')
    }

    const {
        items: records,
        loading,
        fetchRecords
    } = useRatePlans();


    useEffect(() => {
        fetchRecords();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (

        <FormikGenericCombobox
            records={records || []}
            valueFieldName={'id'}
            renderOption={(record: RatePlan) => `${record.name}`}
            getSelectedOption={(record: RatePlan) => `${record.name}`}
            isLoading={loading}
            {...props}
        />

    );
};